import { motion } from "framer-motion";
import { FlaskConical, ShieldCheck, Sprout, Truck } from "lucide-react";
import { certifications } from "@/data/products";

const iconMap = {
  flask: FlaskConical,
  shield: ShieldCheck,
  sprout: Sprout,
  truck: Truck,
};

const Item = ({ c, index }) => {
  const isFlag = c.icon === "flag";
  const Icon = iconMap[c.icon];
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.06 }}
      data-testid={`cert-${c.icon}`}
      className="flex items-center gap-2.5 shrink-0"
    >
      {isFlag ? (
        <img src="/usa-flag.webp" alt="American flag" className="h-4 w-6 rounded-[2px] object-cover ring-1 ring-black/5" />
      ) : (
        <Icon size={18} className="text-[#c79a3e]" />
      )}
      <span className="text-xs sm:text-sm font-medium tracking-tight text-[#1a1f1b]/80 whitespace-nowrap">
        {c.label}
      </span>
    </motion.div>
  );
};

export const TrustBar = () => {
  return (
    <section data-testid="trust-bar" className="border-y border-[#1a1f1b]/10 bg-[#efe9df]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 sm:justify-between">
          {certifications.map((c, i) => (
            <Item key={c.label} c={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
